import React from 'react';
import { Badge } from 'react-bootstrap';
import { Card, CardBody } from 'reactstrap';
import imgDownload from '../../assets/img/mex/planes/download.svg';
import ModalAsistencias from './ModalAsistencias';
import ModalExclusiones from './ModalExclusiones';
import './styles.scss';

const PlanHeader = ({ price, title, subtitle, child = {}, priceUnit, showHeader = true, loading }) => {
  return (
    <>
      <div
        className={` ${showHeader ? 'header-plan' : 'header-only-title'} ${
          child > 1 ? 'header-plan' : 'header-plan-many'
        }`}
      >
        <div className="text-center pt-20 header-title">{title}</div>
        {loading && (
          <div className="text-center">
            <div className="spinnerText text-mex">
              <p>Calculando</p>
            </div>
            <div className="spinnerSKT">
              <div className="skt1"></div>
              <div className="skt2"></div>
              <div className="skt3"></div>
            </div>
          </div>
        )}
        {showHeader && !loading && (
          <div>
            <div className="text-center header-subtitle mt-3">
              {subtitle}
              <Badge pill variant="primary" className="rounded-pill blueLight ml-1" style={{ fontSize: '13px' }}>
                {child}
              </Badge>
              <span className="ml-1">hijo/s</span>
            </div>
            <div className="text-center header-price">{'$' + price}</div>

            {child > 1 && (
              <div>
                <hr className="mx-4"></hr>
                <div className="text-center header-subtitle">
                  Prima total anual por
                  <Badge pill variant="primary" className="blueLight rounded-pill ml-1" style={{ fontSize: '10px' }}>
                    1
                  </Badge>
                  <span className="ml-1">hijo</span>
                </div>
                <div className="text-center header-subtitle `">
                  <span className="header-price"> {'$' + priceUnit}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};
const PlanBody = ({ desde, cobertura, moneda }) => {
  console.log('coberturasArray', cobertura);
  return (
    <CardBody>
      {cobertura.map((item, index) => {
        if (item?.visible) {
          return (
            <div key={index} className="text-center pb-3">
              <p className="text-body">{item.sumaAsegurada === 0.01 ? item.tarifacionCodigo : item.cobertura}</p>
              <p className="text-blue">
                {' '}
                {item.sumaAsegurada === 0.01 ? item.descripcionSuma : '$' + item.sumaAseguradaFormato + ' MXN'}{' '}
              </p>
            </div>
          );
        }
      })}
    </CardBody>
  );
};

const PlanFooter = ({
  showBtnExclusiones = true,
  showBtnAsistencias = true,
  showBtnDescarga = false,
  showContratar = true,
  btnDescargar = 'Descargar cotización',
  plan,
  fnPlan,
  btnContratar = 'Seleccionar',
}) => {
  return (
    <div className="mb-4 container-buttons text-center">
      {showBtnAsistencias && (
        <button
          id=""
          className="mb-4 btn btn-outline-primary-alt font-size-15 text-uppercase "
          type="submit"
          style={{ width: '90%' }}
        >
          <ModalAsistencias data={plan.txtAsistencias}></ModalAsistencias>
        </button>
      )}
      {showBtnExclusiones && (
        <button
          id=""
          className="mb-4 btn btn-outline-primary-alt font-size-15 text-uppercase "
          type="submit"
          style={{ width: '90%' }}
        >
          <ModalExclusiones data={plan.txtExclusion}></ModalExclusiones>
        </button>
      )}

      {showContratar && (
        <button
          id=""
          className="mb-4 btn btn-primary font-size-15 text-uppercase "
          type="submit"
          style={{ width: '90%' }}
          onClick={() => {
            fnPlan(plan.id, plan.uid);
          }}
        >
          {btnContratar}
        </button>
      )}
      {showBtnDescarga && (
        <div>
          <img src={imgDownload} alt="Descarga" />
          <a href={plan.urlPdfCotizacion} target="_blank" rel="noopener noreferrer" className="text-uppercase ml-2">
            {btnDescargar}
          </a>
        </div>
      )}
    </div>
  );
};

const Plan = ({ plan, fnPlan, childSelect, showHeader, showContratar, loading }) => {
  return (
    <Card className="planCard">
      <PlanHeader
        title={plan.producto}
        subtitle="Prima total anual por"
        price={plan.precioFormatoAnual}
        child={childSelect}
        priceUnit={plan.precioFormatoIndividual}
        showHeader={showHeader}
        alMesPlan={plan.precioFormatoMensual}
        alMesPlanIndividual={plan.precioMensualIndividual}
        loading={loading}
      />
      <PlanBody desde={plan.precioFormatoMensual} cobertura={plan.coberturas} />
      <PlanFooter
        plan={plan}
        fnPlan={(planID, PlanUID) => {
          fnPlan(planID, PlanUID);
        }}
        showContratar={showContratar}
      />
    </Card>
  );
};
export default Plan;
